import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { Checkbox } from '@beef/ui-kit';
import { selectIsFttbPersonalVerificationCheckboxEnable } from "../../store/callbackRequest/selectors";
import { selectCheckboxAgreementText, selectIsCheckboxChecked } from "../../store/CheckboxAgreement/selectors";
import { handleCheckboxToggleAnalytics } from "../../store/blocks/addressVerification/actions/handleCheckboxToggleAnalytics";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _CheckboxAgreements = function _CheckboxAgreements(_ref) {
  var isCheckboxChecked = _ref.isCheckboxChecked,
    checkboxText = _ref.checkboxText,
    isCheckboxError = _ref.isCheckboxError,
    changeCheckbox = _ref.changeCheckbox;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-CheckBoxAgreements"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isCheckboxChecked,
    isError: isCheckboxError,
    label: checkboxText,
    name: "selectedAgreement",
    onChange: changeCheckbox
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: selectIsFttbPersonalVerificationCheckboxEnable(state),
    isCheckboxChecked: selectIsCheckboxChecked(state),
    checkboxText: selectCheckboxAgreementText(state)
  };
};
var mapDispatchToProps = {
  changeCheckbox: handleCheckboxToggleAnalytics
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var CheckboxAgreements = compose(connector, withRenderFlag)(_CheckboxAgreements);